export const SET_TOP_MENU = "SET_TOP_MENU";
export const setTopMenu = data => ({
    type: SET_TOP_MENU,
    payload: data
});